<template>
    <div id="navigation-drawer">
        <v-navigation-drawer
            v-model="drawer"
            permanent
            :mini-variant.sync="mini"
            color="#051e34"
            height="100vh"
            :width="220"
            app
        >
            <v-list dark style="padding-top: 70px !important">
                <v-list-item class="logo-bar">
                    <svg
                        width="100"
                        height="24"
                        viewBox="0 0 100 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        v-if="!mini"
                    >
                        <path
                            d="M33.8274 19.4908C34.2864 19.5032 34.7451 19.4579 35.1934 19.3561C35.5009 19.2836 35.7926 19.1528 36.0533 18.9706C36.2551 18.8267 36.4117 18.6258 36.5042 18.3924C36.5896 18.1537 36.6312 17.9009 36.627 17.6466C36.627 17.0646 36.3596 16.5805 35.8248 16.1942C35.29 15.8079 34.3736 15.3922 33.0756 14.9471C32.5064 14.7422 31.9384 14.5066 31.3717 14.2404C30.8168 13.9825 30.3016 13.643 29.8423 13.2326C29.3841 12.8229 29.0085 12.3252 28.7367 11.7676C28.4517 11.194 28.3096 10.4961 28.3104 9.67392C28.2987 8.90774 28.4526 8.1484 28.7613 7.45054C29.0576 6.7977 29.4944 6.22228 30.0389 5.76756C30.6338 5.28201 31.3151 4.91964 32.0449 4.70059C32.9068 4.43931 33.8021 4.31192 34.7008 4.32267C36.4873 4.28351 38.2546 4.70817 39.8381 5.55719L38.7141 8.72284C38.1941 8.45118 37.6535 8.22327 37.0975 8.04134C36.4025 7.83018 35.6798 7.73074 34.9551 7.74657C34.019 7.74657 33.3466 7.87926 32.938 8.14464C32.5293 8.41001 32.3246 8.8169 32.3238 9.36529C32.3141 9.65689 32.3931 9.94435 32.5498 10.1879C32.721 10.431 32.9382 10.6363 33.1886 10.7913C33.49 10.9849 33.8088 11.1486 34.1406 11.2801C34.4993 11.4262 34.8961 11.5748 35.331 11.7298C36.2318 12.0724 37.0172 12.4109 37.6871 12.7451C38.3004 13.0399 38.8629 13.4347 39.3529 13.9141C39.7926 14.3543 40.1309 14.8897 40.343 15.4812C40.5762 16.1839 40.6864 16.9234 40.6686 17.6655C40.6686 19.3283 40.1006 20.6179 38.9647 21.5341C37.8288 22.4503 36.1164 22.9084 33.8274 22.9084C33.1317 22.9131 32.4366 22.866 31.7476 22.7674C31.1936 22.6867 30.6451 22.5706 30.1052 22.4197C29.3764 22.2187 28.6749 21.9254 28.0168 21.5467L29.1224 18.3596C29.7322 18.69 30.3747 18.9526 31.0388 19.1432C31.7955 19.375 32.7251 19.4908 33.8274 19.4908Z"
                            fill="white"
                        />
                        <path
                            d="M47.1598 14.246C47.5275 13.837 47.9071 13.4112 48.2985 12.9686C48.69 12.5261 49.0696 12.0873 49.4373 11.6522C49.8042 11.2172 50.1506 10.8044 50.4765 10.4139C50.8021 10.0222 51.7762 8.65034 52.0096 8.36313H55.9738C55.1925 9.87478 54.0083 11.4305 53.1619 12.3791C52.3155 13.3276 51.3954 14.3064 50.393 15.3155C50.9454 15.8336 51.4641 16.3882 51.9458 16.9758C52.4814 17.6199 52.9993 18.285 53.4997 18.9711C54.0001 19.6573 54.4596 20.3434 54.878 21.0295C55.2957 21.7156 55.6466 22.3421 55.9308 22.909H51.6374C51.3696 22.4631 51.0654 21.9693 50.7247 21.4276C50.384 20.8859 50.0212 20.3451 49.6363 19.8051C49.2514 19.2642 48.8468 18.7448 48.4226 18.2468C48.0378 17.7904 47.6152 17.369 47.1598 16.9871V22.9077H43.4253V1.09082H47.1598V14.246Z"
                            fill="white"
                        />
                        <path
                            d="M69.6466 15.6108C69.658 16.6238 69.5022 17.6315 69.1859 18.5912C68.904 19.4481 68.4504 20.2351 67.8543 20.9015C67.2694 21.543 66.5573 22.0486 65.7659 22.3842C64.9005 22.7452 63.973 22.9238 63.0388 22.9095C62.1127 22.9224 61.1935 22.7437 60.3362 22.3842C59.5449 22.0484 58.8329 21.5429 58.2479 20.9015C57.6514 20.2318 57.1919 19.4462 56.8966 18.5912C56.5615 17.6355 56.3952 16.6263 56.4052 15.6108C56.3925 14.5989 56.5615 13.5932 56.904 12.6441C57.2103 11.7947 57.6808 11.0175 58.2872 10.359C58.8818 9.72493 59.5984 9.22434 60.3915 8.88894C61.2313 8.53266 62.1325 8.35399 63.0413 8.36364C63.9585 8.35257 64.8684 8.53122 65.7168 8.88894C66.5057 9.22341 67.2172 9.72428 67.8052 10.359C68.4009 11.0198 68.8605 11.797 69.1564 12.6441C69.4918 13.5949 69.6578 14.5998 69.6466 15.6108ZM65.7549 15.6108C65.7549 14.4023 65.5203 13.4525 65.051 12.7613C64.5817 12.0701 63.9118 11.7246 63.0413 11.7246C62.1707 11.7246 61.4963 12.0701 61.018 12.7613C60.5397 13.4525 60.301 14.4023 60.3018 15.6108C60.3018 16.8184 60.5406 17.7766 61.018 18.4854C61.4955 19.1942 62.1699 19.5486 63.0413 19.5486C63.9118 19.5486 64.5817 19.1942 65.051 18.4854C65.5203 17.7766 65.7549 16.8184 65.7549 15.6108Z"
                            fill="white"
                        />
                        <path
                            d="M78.0356 22.8057C76.9497 22.7893 75.5419 22.6697 74.8662 22.4467C74.266 22.2697 73.7159 21.9479 73.2619 21.5082C72.8683 21.1047 72.5908 20.5978 72.4597 20.0432C72.3107 19.4081 72.2393 18.7564 72.2472 18.1032V1.09082H75.9804V17.3323C75.9781 17.6426 76.0032 17.9525 76.0553 18.2582C76.0966 18.5093 76.1955 18.7468 76.344 18.951C76.5072 19.1563 76.7185 19.3159 76.9583 19.4146C77.3026 19.5516 77.6666 19.6295 78.0356 19.6451V22.8057Z"
                            fill="white"
                        />
                        <path
                            d="M85.9537 22.8057C84.8666 22.7893 83.46 22.6697 82.7831 22.4467C82.1831 22.2695 81.633 21.9477 81.1788 21.5082C80.7857 21.1046 80.5085 20.5977 80.3779 20.0432C80.2284 19.4081 80.1566 18.7565 80.1641 18.1032V1.09082H83.8986V17.3323C83.8957 17.6426 83.9208 17.9526 83.9735 18.2582C84.0142 18.5095 84.1132 18.7471 84.2622 18.951C84.4252 19.1565 84.6366 19.3161 84.8764 19.4146C85.2212 19.5514 85.5856 19.6293 85.955 19.6451L85.9537 22.8057Z"
                            fill="white"
                        />
                        <path
                            d="M98.9379 12.4862V22.5261C98.9379 22.5261 94.6028 22.904 93.249 22.904C92.4692 22.8999 91.692 22.81 90.9309 22.6357C90.2915 22.4916 89.6851 22.2226 89.1448 21.8433C88.6484 21.4978 88.2507 21.023 87.9925 20.4677C87.7247 19.9025 87.5912 19.2089 87.592 18.3867C87.592 17.5981 87.7464 16.9296 88.0552 16.3812C88.3543 15.8442 88.7812 15.3935 89.2959 15.0711C89.8452 14.7333 90.4468 14.4943 91.0747 14.3644C91.7589 14.217 92.4565 14.144 93.1557 14.1465C93.5864 14.144 94.017 14.165 94.4455 14.2095C94.7544 14.2408 95.0604 14.2968 95.3607 14.377V13.3693C95.3601 13.1887 95.3247 13.01 95.2567 12.8434C95.1887 12.6768 95.0893 12.5256 94.9643 12.3985C94.8392 12.2713 94.691 12.1707 94.528 12.1023C94.365 12.0339 94.1904 11.9991 94.0143 11.9999H88.6461V8.36316H94.9111C95.4396 8.36234 95.9631 8.46837 96.4516 8.6752C96.9402 8.88203 97.3841 9.1856 97.7581 9.56854C98.1321 9.95148 98.4289 10.4063 98.6313 10.9069C98.8337 11.4076 98.9379 11.9442 98.9379 12.4862ZM93.4996 19.8769C93.8673 19.8769 94.2183 19.8681 94.5524 19.8505C94.821 19.8408 95.0889 19.8152 95.3546 19.7736V16.8763C95.2035 16.8423 94.9787 16.8083 94.6777 16.773C94.4032 16.7408 94.1272 16.7239 93.851 16.7226C93.5199 16.7213 93.1891 16.7427 92.8608 16.7868C92.5781 16.8212 92.3029 16.9034 92.0464 17.03C91.8238 17.1403 91.6335 17.3089 91.4948 17.5187C91.3543 17.7494 91.2845 18.0179 91.2946 18.2897C91.2946 18.8893 91.4907 19.3046 91.883 19.5355C92.2753 19.7665 92.8142 19.8803 93.4996 19.8769Z"
                            fill="white"
                        />
                        <path
                            d="M14.4107 14.7766L12.0767 15.9544C12.1327 15.936 12.1873 15.9133 12.24 15.8864L14.4107 14.7766Z"
                            fill="white"
                        />
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M5.35466 22.909H18.0494C18.6129 22.909 19.1708 22.7952 19.6914 22.5741C20.212 22.3529 20.6851 22.0288 21.0835 21.6202C21.482 21.2116 21.798 20.7266 22.0137 20.1927C22.2293 19.6589 22.3403 19.0867 22.3403 18.5088V5.49099C22.3405 4.9131 22.2296 4.34085 22.014 3.80692C21.7984 3.27299 21.4824 2.78786 21.0839 2.37923C20.6854 1.9706 20.2123 1.6465 19.6916 1.42543C19.171 1.20436 18.6129 1.09066 18.0494 1.09082H5.35466C4.21664 1.09082 3.12522 1.55441 2.32051 2.3796C1.5158 3.20479 1.06372 4.32399 1.06372 5.49099V18.5088C1.06372 19.6758 1.5158 20.795 2.32051 21.6202C3.12522 22.4454 4.21664 22.909 5.35466 22.909ZM8.03923 14.2866L11.1607 15.8865C11.4447 16.0303 11.7722 16.0547 12.0734 15.9545H12.0796C12.1356 15.9361 12.1902 15.9133 12.243 15.8865L14.4148 14.7766L16.9405 13.4993C17.06 13.6963 17.1234 13.9236 17.1236 14.1556V15.3964C17.1236 15.6271 17.061 15.8532 16.9427 16.0495C16.8245 16.2457 16.6553 16.4043 16.454 16.5075L12.2491 18.6641C12.0809 18.7505 11.8954 18.7954 11.7074 18.7954C11.5193 18.7954 11.3338 18.7505 11.1656 18.6641L6.96066 16.5075C6.75854 16.405 6.58832 16.2467 6.46917 16.0504C6.35002 15.8541 6.28667 15.6276 6.28624 15.3964C6.28643 15.1848 6.33934 14.9767 6.43996 14.7919C6.54058 14.6072 6.68558 14.4518 6.86118 14.3407C7.03679 14.2295 7.23719 14.1662 7.44336 14.1567C7.64953 14.1472 7.85464 14.192 8.03923 14.2866ZM6.47662 10.513C6.59581 10.702 6.76263 10.8543 6.9594 10.9539L14.4136 14.7759L16.9343 13.4998C16.8152 13.3042 16.6449 13.1466 16.443 13.045L8.99419 9.22334L11.0205 8.18329L11.1594 8.11202L11.0954 8.14487L11.1591 8.11218C11.3271 8.02604 11.5123 7.98119 11.7002 7.98119C11.888 7.98119 12.0733 8.02604 12.2413 8.11218L15.3628 9.71202C15.5055 9.7901 15.662 9.83809 15.8231 9.85314C15.9841 9.8682 16.1465 9.85002 16.3006 9.79968C16.4548 9.74934 16.5975 9.66786 16.7204 9.56004C16.8433 9.45223 16.9439 9.32026 17.0163 9.17192C17.0886 9.02359 17.1313 8.86189 17.1417 8.69638C17.1522 8.53086 17.1302 8.36488 17.0771 8.20822C17.0239 8.05156 16.9408 7.9074 16.8324 7.78424C16.7241 7.66109 16.5928 7.56143 16.4463 7.49115L12.2413 5.33452C12.073 5.24874 11.8876 5.2041 11.6996 5.2041C11.5116 5.2041 11.3262 5.24874 11.1578 5.33452L6.95902 7.49115C6.75782 7.59432 6.58862 7.75291 6.47037 7.94915C6.35212 8.1454 6.2895 8.37153 6.28952 8.60221V9.84303C6.28999 10.0798 6.35605 10.3116 6.47999 10.5113L6.47662 10.513ZM6.47999 10.5113C6.48038 10.5119 6.48077 10.5126 6.48116 10.5132L8.99419 9.22334L8.9937 9.22309L11.0205 8.18329L11.0954 8.14487L6.47999 10.5113Z"
                            fill="white"
                        />
                    </svg>

                    <v-btn
                        style="margin-left: -7px"
                        v-else
                        icon
                        @click.stop="mini = !mini"
                    >
                        <v-icon class="white--text">mdi-close</v-icon>
                    </v-btn>

                    <v-spacer />
                    <v-btn v-show="!mini" icon @click.stop="mini = !mini">
                        <v-icon class="white--text">mdi-menu</v-icon>
                    </v-btn>
                </v-list-item>

                <template>
                    <template v-for="item in items">
                        <v-list-item
                            v-if="!item.child"
                            :key="item.title"
                            link
                            :to="item.to"
                            :id="item.id"
                            class="my-2"
                            style="text-decoration: none"
                        >
                            <v-list-item-icon>
                                <v-icon class="white--text">{{
                                    item.icon
                                }}</v-icon>
                            </v-list-item-icon>

                            <v-list-item-content>
                                <v-list-item-title
                                    class="text-subtitle-2 white--text"
                                    >{{ item.title }}</v-list-item-title
                                >
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-group
                            v-else
                            :key="item.title"
                            class="my-2"
                            active-class="white--text"
                            no-action
                            link
                            :id="item.id"
                            style="text-decoration: none"
                        >
                            <template v-slot:append-icon>
                                <v-icon>mdi-chevron-down</v-icon>
                            </template>
                            <template v-slot:activator>
                                <v-list-item-icon>
                                    <v-icon class="white--text">{{
                                        item.icon
                                    }}</v-icon>
                                </v-list-item-icon>

                                <v-list-item-content>
                                    <v-list-item-title
                                        class="text-subtitle-2 white--text"
                                        >{{ item.title }}</v-list-item-title
                                    >
                                </v-list-item-content>
                            </template>
                            <v-list-item
                                v-for="child in item.child"
                                :key="child.title"
                                :to="child.to"
                                :id="child.id"
                                exact
                                class="my-2 pl-3"
                                style="text-decoration: none"
                            >
                                <v-list-item-icon>
                                    <v-icon class="white--text">{{
                                        child.icon
                                    }}</v-icon>
                                </v-list-item-icon>

                                <v-list-item-content>
                                    <v-list-item-title
                                        class="text-subtitle-2 white--text pa-0"
                                        >{{ child.title }}</v-list-item-title
                                    >
                                </v-list-item-content>
                            </v-list-item>
                        </v-list-group>
                    </template>
                </template>
            </v-list>
        </v-navigation-drawer>
    </div>
</template>

<script>
import { mapState } from "vuex";
import bimbelService from "@/modules/bimbel_online/services/bimbel.js";
import itembankService from "@/modules/itembank/services/itembank.js";

export default {
    data() {
        return {
            drawer: true,
            items: [],
            banksoal: [],
            mini: false,
            selectedItem: 0,
        };
    },

    mounted: function () {
        App.init();
    },

    computed: {
        ...mapState(["auth"]),
    },

    methods: {
        loadbanksoal: function () {
            var context = this;
            itembankService.getListMataPelajaran(function (result) {
                if (result.success) {
                    localStorage.setItem("mapels", JSON.stringify(result.data));
                    var reportMenu = {
                        to: {
                            path: "/list-report",
                        },
                        title: "Laporan Soal",
                        id: "menu_laporan_soal",
                    };
                    context.banksoal.push(reportMenu);
                    result.data.forEach(function (item) {
                        context.banksoal.push({
                            to: {
                                path: "/items",
                                query: { mapel: item.id },
                            },
                            title: item.nama,
                            id: "menu_bank_soal_" + item.id,
                            icon: "",
                        });
                    });
                }
            });

            bimbelService.getListKurikulum(function (result) {
                if (result.success) {
                    localStorage.setItem(
                        "kurikulum",
                        JSON.stringify(result.data)
                    );
                    result.data.forEach(function (item) {
                        context.banksoal.push({
                            to: {
                                path: "/items",
                                query: { mapel: item.id },
                            },
                            title: item.nama,
                            icon: "",
                        });
                    });
                }
            });
        },

        roleVerify: function () {
            this.items.push({
                title: "Dashboard",
                to: { path: "/" },
                icon: "mdi-chart-box-outline",
                id: "menu_dashboard",
            });

            if (this.auth.scopes.includes("admin_oss")) {
                this.items.push({
                    title: "OSS Config",
                    to: { path: "/" },
                    id: "menu_oss_config",
                    child: [
                        {
                            title: "Banner Landing Page",
                            to: { path: "/landing-banners" },
                            icon: "",
                            id: "menu_oss_config_banner_landing",
                        },
                        {
                            title: "Banner Android",
                            to: { path: "/android-banners" },
                            icon: "",
                            id: "menu_oss_config_banner_android",
                        },
                        {
                            title: "Banner Webapp",
                            to: { path: "/webapp-banners" },
                            icon: "",
                            id: "menu_oss_config_banner_webapp",
                        },
                        {
                            title: "Banner IOS",
                            to: { path: "/ios-banners" },
                            icon: "",
                            id: "menu_oss_config_banner_ios",
                        },
                    ],
                    icon: "mdi-cog-sync-outline",
                });
            }

            if (this.auth.scopes.includes("admin_pop_ads")) {
                this.items.push({
                    title: "Pop Up Ads",
                    to: { path: "/pop-up-ads" },
                    id: "menu_pop_up_ads",
                    icon: "mdi-application-cog-outline",
                });
            }

            if (this.auth.scopes.includes("admin_ambis_meter")) {
                this.items.push({
                    title: "Ambis Meter",
                    to: { path: "/ambis-meter" },
                    icon: "mdi-chart-bar",
                    id: "menu_ambis_meter",
                    child: [
                        {
                            title: "Periode",
                            to: { path: "/ambis-meter" },
                            id: "menu_ambis_meter_quote",
                        },
                        {
                            title: "Quotes",
                            to: { path: "/quote" },
                            id: "menu_ambis_meter_quote",
                        },
                        // {
                        //   title: "Info",
                        //   to: { path: "/info" },
                        //   icon: "mdi-circle-small",
                        //   id: "menu_ambis_meter_info",
                        // },
                    ],
                });
            }

            if (this.auth.scopes.includes("admin_ambis_test")) {
                this.items.push({
                    title: "Ambis Test",
                    icon: "mdi-chart-line",
                    id: "menu_ambis_test",
                    child: [
                        {
                            title: "Tema Skala",
                            to: { path: "/ambis-test" },
                            id: "menu_ambis_test_tema",
                        },
                        {
                            title: "Bundle Subtes",
                            to: { path: "/ambis-test/list-bundle" },
                            id: "menu_ambis_test_bundle",
                        },
                    ],
                });

                // this.items.push({
                //     title: "Ambis Test",
                //     to: { path: "/ambis-test" },
                //     icon: "mdi-help-box",
                //     id: "menu_ambis_test",
                // });
            }

            if (this.auth.scopes.includes("admin_notifikasi")) {
                this.items.push({
                    title: "Notifications Template",
                    to: { path: "/notifications-template" },
                    icon: "mdi-bell-badge-outline",
                    id: "menu_notifications_template",
                });
            }

            if (this.auth.scopes.includes("admin_userman")) {
                this.items.push({
                    title: "User Management",
                    to: { path: "/user-management" },
                    icon: "mdi-account-multiple-outline",
                    id: "menu_user_management",
                });
            }

            if (this.auth.scopes.includes("admin_user_group")) {
                this.items.push({
                    title: "User Group",
                    to: { path: "/user-group" },
                    icon: "mdi-account-multiple",
                    id: "menu_user_management",
                });
            }

            if (this.auth.scopes.includes("admin_code")) {
                this.items.push({
                    title: "Activation Code",
                    to: { path: "/code-activation" },
                    icon: "mdi-account-convert",
                    id: "menu_code_activation",
                });
            }

            if (this.auth.scopes.includes("admin_consul")) {
                // this.items.push({
                //   title: "Konsul",
                //   to: { path: "/konsul" },
                //   icon: "mdi-forum-outline",
                //   id: "menu_consul",
                // });

                this.items.push({
                    title: "Konsul",
                    to: { path: "/konsul" },
                    id: "menu_konsul",
                    child: [
                        {
                            title: "Manajemen Konsultan",
                            to: { path: "/konsul/management" },
                            icon: "",
                            id: "menu_consultant_management",
                        },
                        {
                            title: "Aktivitas Konsul",
                            to: { path: "/konsul/activity" },
                            icon: "",
                            id: "menu_consul_activity",
                        },
                        {
                            title: "Chat Konsul",
                            to: { path: "/konsul/chat" },
                            icon: "",
                            id: "menu_consul_chat",
                        },
                        {
                            title: "Sinkronisasi Waktu Aktif",
                            to: { path: "/konsul/time-active" },
                            icon: "",
                            id: "menu_consul_time_active",
                        },
                    ],
                    icon: "mdi-forum-outline",
                });
            }

            if (this.auth.scopes.includes("admin_tryout")) {
                var tryout_child = [];

                if (this.auth.scopes.includes("admin_tryout")) {
                    tryout_child.push({
                        title: "Tryout",
                        to: { path: "/tryouts" },
                        icon: "",
                        id: "menu_tryouts",
                    });
                }

                if (this.auth.scopes.includes("admin_tryout")) {
                    tryout_child.push({
                        title: "Tryout Group",
                        to: { path: "/tryout-groups" },
                        icon: "",
                        id: "menu_tryout_groups",
                    });
                }

                if (this.auth.scopes.includes("admin_tryout")) {
                    tryout_child.push({
                        title: "Tryout Serial",
                        to: { path: "/serial" },
                        icon: "",
                        id: "menu_tryout_serial",
                    });
                }

                if (this.auth.scopes.includes("admin_tryout_member")) {
                    tryout_child.push({
                        title: "Tryout Members",
                        to: { path: "/tryout-members" },
                        icon: "",
                        id: "menu_tryout_members",
                    });
                }

                this.items.push({
                    title: "Tryout",
                    to: { path: "/tryout-menu" },
                    id: "menu_tryout",
                    child: tryout_child,
                    icon: "mdi-folder-file-outline",
                });
            }

            // if (
            //   this.auth.scopes.includes("admin_itembank") ||
            //   this.auth.scopes.includes("admin_operational") ||
            //   this.auth.scopes.includes("admin_userman") ||
            //   this.auth.scopes.includes("read_tryout") ||
            //   this.auth.scopes.includes("write_tryout")
            // ) {
            //   this.items.push({
            //     title: "Tryout Members",
            //     to: { path: "/tryout-members" },
            //     icon: "mdi-account-group-outline",
            //     id: "menu_tryout_members",
            //   });
            // }

            // if (
            //   this.auth.scopes.includes("admin_itembank") ||
            //   this.auth.scopes.includes("read_tryout")
            // ) {
            //   this.items.push({
            //     title: "Tryout",
            //     to: { path: "/tryouts" },
            //     icon: "mdi-file-document-outline",
            //     id: "menu_tryouts",
            //   });
            // }

            if (this.auth.scopes.includes("admin_liveclass")) {
                this.items.push({
                    title: "Live Class",
                    to: { path: "/liveclass" },
                    id: "menu_liveclass",
                    child: [
                        {
                            title: "Live Class",
                            to: { path: "/live-class" },
                            icon: "",
                            id: "menu_live_class",
                        },
                        {
                            title: "Live Class Teacher",
                            to: { path: "/live-class-teacher" },
                            icon: "",
                            id: "menu_live_class",
                        },
                    ],
                    icon: "mdi-radio-tower",
                });
            }

            // this.items.push({
            //   title: "Live Class",
            //   to: { path: "/live-class" },
            //   icon: "mdi-radio-tower",
            //   id: "menu_live_class",
            // });

            // this.items.push({
            //   title: "Live Class Teacher",
            //   to: { path: "/live-class-teacher" },
            //   icon: "mdi-laptop-account",
            //   id: "menu_live_class",
            // });

            // if (this.auth.scopes.includes("admin_modul")) {
            //     this.items.push({
            //         title: "Modul Pembelajaran",
            //         to: { path: "/modul-belajar" },
            //         id: "menu_modul_belajar",
            //         child: [
            //             {
            //                 title: "Modul Pembelajaran 2022",
            //                 to: { path: "/modul-pembelajaran" },
            //                 icon: "",
            //                 id: "menu_modul_pembelajaran_2022",
            //             },
            //             {
            //                 title: "Modul Pembelajaran (Lama)",
            //                 to: { path: "/modul-pembelajaran-old" },
            //                 icon: "",
            //                 id: "menu_modul_pembelajaran",
            //             },
            //         ],
            //         icon: "mdi-folder-file-outline",
            //     });
            // }

            if (this.auth.scopes.includes("admin_modul")) {
                this.items.push({
                    title: "Modul Pembelajaran",
                    to: { path: "/modul-pembelajaran" },
                    icon: "mdi-folder-file-outline",
                    id: "menu_modul_pembelajaran",
                });
            }

            // if (
            //     this.auth.scopes.includes("admin_itembank") ||
            //     this.auth.scopes.includes("tmp_itembank")
            // ) {
            //     this.items.push({
            //         title: "Modul Pembelajaran",
            //         to: { path: "/modul-pembelajaran-old" },
            //         icon: "mdi-folder-file-outline",
            //         id: "menu_modul_pembelajaran",
            //     });
            // }

            // if (
            //     this.auth.scopes.includes("admin_itembank") ||
            //     this.auth.scopes.includes("tmp_itembank")
            // ) {
            //     this.items.push({
            //         title: "Bank Soal",
            //         to: { path: "/items" },
            //         child: this.banksoal,
            //         icon: "mdi-book-open-outline",
            //         id: "menu_bank_soal",
            //     });
            // }

            if (
                this.auth.scopes.includes("admin_itembank") ||
                this.auth.scopes.includes("tmp_itembank")
            ) {
                this.items.push({
                    title: "Bank Soal",
                    to: { path: "/items" },
                    child: [
                        {
                            title: "Laporan Soal",
                            to: { path: "/list-report" },
                            icon: "",
                            id: "menu_laporan_soal",
                        },
                        {
                            title: "Daftar Soal",
                            to: { path: "/items" },
                            icon: "",
                            id: "menu_daftar_soal",
                        },
                        {
                            title: "Tambah Soal",
                            to: { path: "/item-form?mapel=1" },
                            icon: "",
                            id: "menu_tambah_soal",
                        },
                    ],
                    icon: "mdi-book-open-outline",
                    id: "menu_bank_soal",
                });
            }

            if (this.auth.scopes.includes("admin_itembank")) {
                this.items.push({
                    title: "Kodifikasi",
                    to: { path: "/topic-management" },
                    id: "menu_kodifikasi",
                    child: [
                        {
                            title: "Pengaturan Bab",
                            to: { path: "/topic-management" },
                            icon: "",
                            id: "menu_pengaturan_bab",
                        },
                        {
                            title: "Mapping",
                            to: { path: "/topic-mapping" },
                            icon: "",
                            id: "menu_topic_mapping",
                        },
                    ],
                    icon: "mdi-folder-file-outline",
                });
            }

            if (this.auth.scopes.includes("admin_sales")) {
                this.items.push({
                    title: "Transaksi",
                    to: { path: "/pembayaran" },
                    id: "pembayaran",
                    child: [
                        {
                            title: "Kode Referral",
                            to: { path: "/referral-code" },
                            icon: "",
                            id: "menu_referral",
                        },
                        {
                            title: "Paket",
                            to: { path: "/produk" },
                            icon: "",
                            id: "menu_paket",
                        },
                        {
                            title: "Testimoni",
                            to: { path: "/testimoni" },
                            icon: "",
                            id: "menu_testimoni",
                        },
                        {
                            title: "Jadwal Kelas",
                            to: { path: "/jadwal-kelas" },
                            icon: "",
                            id: "menu_jadwal_kelas",
                        },
                        {
                            title: "Transaksi",
                            to: { path: "/transaksi" },
                            icon: "",
                            id: "menu_transaksi",
                        },
                    ],
                    icon: "mdi-credit-card-multiple-outline",
                });
            }

            if (this.auth.scopes.includes("admin_video")) {
                this.items.push({
                    title: "Video Pembelajaran",
                    to: { path: "/video" },
                    icon: "mdi-video-outline",
                    id: "menu_video_pembelajaran",
                });
            }
        },
    },

    created: function () {
        this.loadbanksoal();
        this.roleVerify();
    },
};
</script>



// WEBPACK FOOTER //
// TheNavigationDrawer.vue?116e4b8c